import { Flex, Grid, Text } from '@radix-ui/themes'
import { EventsShowCarDetail } from '@/types/events_show'

/**
 * A car's photos and specs, as the expanded card on an event page and the car's
 * own page both show them.
 */
export function CarPhotoGrid({ photos, driverName, height = 200 }: { photos: EventsShowCarDetail['photos']; driverName: string; height?: number }) {
  if (photos.length === 0) return null

  return (
    <Grid columns={{ initial: '1', sm: String(Math.min(photos.length, 3)) }} gap="2">
      {photos.map((photo, i) => (
        // A new tab rather than a lightbox: it keeps the back gesture honest.
        <a key={i} href={photo.original_url ?? photo.full_url ?? undefined} target="_blank" rel="noopener noreferrer">
          <img
            src={photo.full_url ?? photo.thumb_url ?? undefined}
            alt={`Photo ${i + 1} of ${driverName}'s car`}
            loading="lazy"
            style={{ display: 'block', width: '100%', height, objectFit: 'cover', borderRadius: 8, background: 'var(--gray-4)' }}
          />
        </a>
      ))}
    </Grid>
  )
}

export function CarSpecList({ specs }: { specs: EventsShowCarDetail['specs'] }) {
  if (specs.length === 0) return null

  return (
    <Grid columns="2" gapX="4" gapY="1">
      {specs.map((spec) => (
        <Flex key={spec.label} direction="column">
          <Text size="1" color="gray">{spec.label}</Text>
          <Text size="2">{spec.value}</Text>
        </Flex>
      ))}
    </Grid>
  )
}
